module.exports = __webpack_public_path__ + "static/img/anliyxpic.14f3a55.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/anliyxpic.jpg
// module id = y4Xa
// module chunks = 1